import type { DocumentWithChildren } from '../types';
import type { BaseMapper } from './interfaces';

export const createBaseMapper = <TModel, TEntity>(): BaseMapper<TModel, TEntity> => ({
  toDomain(model: TModel) {
    return model as unknown as TEntity;
  },
  toDomainArray(models: TModel[]) {
    return models as unknown as TEntity[];
  },
  toDomainTree(models: DocumentWithChildren<TModel>[]) {
    return models as unknown as DocumentWithChildren<TEntity>[];
  },
  fromDomain(entity: TEntity) {
    return entity as unknown as TModel;
  },
  fromDomainArray(entities: TEntity[]) {
    return entities as unknown as TModel[];
  },
  fromDomainTree(entities: DocumentWithChildren<TEntity>[]) {
    return entities as unknown as DocumentWithChildren<TModel>[];
  },
});
